import PropTypes from 'prop-types';
import PortalImpl from './portal.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Renders `children` into the DOM element identified by the `targetId` config value, wherever
 * that element currently lives in the document. Use it to place content from a page (or any
 * component) into a named slot owned by another, persistent part of the UI, for example a
 * container rendered by the application shell that does not remount on navigation, so different
 * routes can each supply their own content for that slot without the persistent container needing
 * to know which route is active.
 * <br><br>
 * Renders nothing until an element with a matching `id` exists, observing a configured DOM subtree
 * (or `document.body` when no observe root is configured) until it appears.
 *
 * @class Portal
 * @memberof Mojito.Presentation.Components
 */

/**
 * `Portal` prop types.
 *
 * @property {node} [children] - Content to render into the target element.
 * @memberof Mojito.Presentation.Components.Portal
 */
const propTypes = {
    children: PropTypes.node,
};

export default UIView('Portal', PortalImpl, propTypes);
